import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'libero-string-searchbar',
  templateUrl: './string-searchbar.component.html',
  styleUrls: ['./string-searchbar.component.scss'],
  standalone: false
})
export class StringSearchbarComponent implements OnInit, OnDestroy {
  @Input() public formName!: AbstractControl;
  @Input() public placeholder?: string;

  public currentInputValue?: string;

  private formSubscription?: Subscription;

  public ngOnInit(): void {
    this.formSubscription = this.formName.valueChanges.pipe().subscribe( changes => this.resetValue(changes) );
  }

  private resetValue(changes: unknown): void {
    if(changes === '') {
      this.currentInputValue = '';
    }
  }

  public reset(): void {
    this.formName.patchValue('');
    this.resetValue('');
  }

  public textInputUpdated(): void {
    this.formName.patchValue(this.currentInputValue);
    this.formName.markAsTouched();
    this.formName.markAsDirty();
  }

  public ngOnDestroy(): void {
    this.formSubscription?.unsubscribe();
  }
}
